import type { WorkflowPublishIssue } from '@streamlain/workflow-field-schemas';

/**
 * The server refused to publish a workflow and named the fields that keep it
 * from being published. `message` is the server's English summary.
 */
export class WorkflowPublishRefusedError extends Error {
  constructor(
    message: string,
    readonly issues: readonly WorkflowPublishIssue[]
  ) {
    super(message);
    this.name = 'WorkflowPublishRefusedError';
  }
}
